import { UpdateUserRequest } from "models/request";
import { ZPlayNetworkService } from "../commons/zplay-network-service";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class UserService {

    public static getUserListPaginated = (queryParams: Array<[string, any]> | null = null, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/users/paginated-list`, callback, errCallback, queryParams);
    };

    public static createUser = (request: UpdateUserRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.postEmptyResponse(`${API_BASE_URL}/api/backoffice/users`, request, callback, errCallback);
    };

    public static updateUser = (id: string, request: UpdateUserRequest, callback: any, errCallback: any) => {
        ZPlayNetworkService.put(`${API_BASE_URL}/api/backoffice/users/${id}`, request, callback, errCallback);
    }

    public static getUserById = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/backoffice/users/${id}`, callback, errCallback);
    };

    public static deleteUser = (id: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.deleteEmptyResponse(`${API_BASE_URL}/api/backoffice/users/${id}`, callback, errCallback);
    };

    public static createUsersFromCSV = (base64File: string, type: string, callback: any, errCallback: any) => {
        ZPlayNetworkService.post(`${API_BASE_URL}/api/backoffice/users/csv?type=${type}`,{file: base64File},  callback, errCallback );
    };
 
}
